import { Flex, type FlexProps } from 'antd';
import styled from 'styled-components';
import { IconBadge } from './IconBadge.tsx';

const SectionTitleWrapper = styled(Flex)`
  min-height: 40px;
  justify-content: center;
  .title, .description {
    margin: 0;
    padding: 0;
  }
  .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
  }
  .description {
    font-size: 15px;
    font-weight: 400;
    line-height: 1.2;
    color: ${props => props.theme.colorTextSecondary};
  }
`;

export interface ISectionTitleProps
  extends Omit<FlexProps, 'title' | 'children'> {
  title: React.ReactNode;
  icon: React.ReactNode;
  description?: React.ReactNode;
}

/**
 * Titolo stilizzato che racchiude le sezioni del riepilogo esteso.
 * Utilizzato per evidenziare visivamente le diverse sezioni del riepilogo esteso.
 */
export function SectionTitle(props: ISectionTitleProps) {
  const { title, icon, description, ...otherProps } = props;

  return (
    <Flex align="center" gap={16} {...otherProps}>
      <IconBadge icon={icon} />

      <SectionTitleWrapper vertical gap={6}>
        <div className="title">{title}</div>
        {description && <div className="description">{description}</div>}
      </SectionTitleWrapper>
    </Flex>
  );
}
